export const PLAYERS = ['X', 'O']
export const DEFAULT_TURN = 'X'

// styling configs
export const PLAYER_COLOR_CLASS = {
  X: 'text-blue-500',
  O: 'text-green-500',
}
